import { getDataDict, getHerbal, getHerbalList } from "@/api";

/**
 * 数据字典,按需维护
 * 字段名必须与接口一致
 * https://console-docs.apipost.cn/preview/522068764c91ac45/fc977eecd937842c?target_id=3b0ab7f7-6180-46b8-9c09-34579373368e
 */
const state = {
  herbal: [],

  hotHerbals: [],

  tenDrug: []
};

const mutations = {
  SET_HERBAL: (state, herbal) => {
    state.herbal = herbal;
  },
  SET_HOT_HERBALS: (state, hotHerbals) => {
    state.hotHerbals = hotHerbals;
  },
  SET_TEN_DRUG: (state, tenDrug) => {
    state.tenDrug = tenDrug;
  },
};

const actions = {
  async getDataDict({ commit }, codes) {
    try {
      const result = await getDataDict({ parent_code: codes });

      const data = result.data;

      const keys = Object.keys(data);

      keys.forEach((key) => {
        const KEY = key.toUpperCase();

        commit(`SET_${KEY}`, result.data[key]);
      });

      return result.data;
    } catch (error) {
      console.log(error);

      return Promise.reject(error);
    }
  },

  async getHotHerbals({ commit }) {
    try {
      const { code, data, message } = await getHerbal({ is_hot: 1 });
      if (code !== 0) throw new Error(message);

      commit(`SET_HOT_HERBALS`, data.data_list);

      return data.data_list;
    } catch (error) {
      console.log(error);

      return Promise.reject(error);
    }
  },

  async getTenDrug({ commit }) {
    try {
      const { code, data, message } = await getHerbalList();
      if (code !== 0) throw new Error(message);

      commit(`SET_TEN_DRUG`, data.data_list);

      return data.data_list;
    } catch (error) {
      console.log(error);

      return Promise.reject(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
